import '../../App.point.css';
import React, { Component } from 'react';
import fn_set_footer from './StdtMenuCmp';
import $ from 'jquery';
import { udfAutoLogin, url, udfInlineLoading, udfNoneLoading, AlertModal, udfLogOut } from '../../common/common';
import loader from '../../imgs/ajax-loader.gif';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowCircleLeft, faChevronCircleRight } from '@fortawesome/free-solid-svg-icons';
import { Navbar, ListGroup } from 'react-bootstrap';

class RuleDetailListCmp extends Component {
  constructor(props) {
    super(props);

    this.state = {

      // bootstrap Alert 변수
      alertShow: false,
      alertClickNo: null,
      alertClickYes: null,
      alertClickOk: null,
      alertMessage: null,

      clCd: props.match.params.clCd,
      list: null,
      isLoggedIn: null,
      CL_GU: '',
      CL_NM: '',

      usrInfo: null,
      clGuNm: { B: '상점', R: '벌점', G: '회복', S: '차감' },
    }
  }

  componentDidMount = () => {
    // 자동 로그인 체크
    udfAutoLogin(this).then((data) => {
      if (data !== null && data.userSe === 'STDT') {
        this.setState({ usrInfo: data, clGuNm: { B: data.BLUE_NM, R: data.RED_NM, G: '회복', S: '차감' } });
        this.udfSelectRuleInfoList();
      } else if (data !== null && data.userSe === 'USR') {
        this.props.history.push('/menuList');
      } else {
        this.props.history.push('/');
      }
    });

    // 로그아웃 버튼 바인딩
    document.getElementById("logoutBtn").addEventListener('click', () => { udfLogOut(this) });
    // 뒤로 이동 버튼 바인딩
    $('.goBackBtn').on('click', () => {
      if (this.props.history !== null && typeof (this.props.history) !== undefined) this.props.history.go(-1);
    });
  }

  udfSelectRuleInfoList = () => {
    if (!this.state.usrInfo) return;

    let that = this;

    udfInlineLoading();

    $.ajax({
      url: url + '/slp/stdt/selectRuleInfoListJSON.do',
      type: 'GET',
      dataType: 'jsonp',
      data: { SF_CL_CD: that.state.clCd, isMobile: 'Y' },
      success: function (data) {
        udfNoneLoading();

        if (!data.success)
          that.componentDidMount();
        else {

          if (data.login === "0") {
            that.setState({
              isLoggedIn: false
            });
          } else {
            let list = [];
            let clGu = '';
            let clNm = '';

            $.each(data.list, function (idx, val) {
              if (clGu === '') clGu = that.state.clGuNm[val.CL_GU];
              if (clNm === '') clNm = val.CL_NM;

              list.push({
                RL_DESC: val.RL_DESC,
                POINT: val.POINT,
              });
            });

            that.setState({
              isLoggedIn: true,
              CL_GU: clGu,
              CL_NM: clNm,
              list: list,
            });
          }
        }
      },
      error: function (jqXHR, status, error) {
        udfNoneLoading();
        that.componentDidMount();
      }
    });
  }

  render() {
    const resultList = this.state.list === null ? null :
      this.state.list.map((data, idx) => (
        <ListGroup.Item key={idx}>
          <div className='row'>
            <div className='col'><FontAwesomeIcon icon={faChevronCircleRight} /> {data.RL_DESC}</div>
            {
              this.state.usrInfo && this.state.usrInfo.RATING_GU !== "Z" ?
                <div className='col-3 point text-right'>
                  {data.POINT} 점
                </div>
                : ""
            }
          </div>
        </ListGroup.Item>
      ));
    return (
      <>
        <AlertModal
          show={this.state.alertShow}
          onHide={this.alertClose}
          Title="스쿨라이프"
          Message={this.state.alertMessage}
          onClickOk={this.state.alertClickOk}
          onClickNo={this.state.alertClickNo}
          onClickYes={this.state.alertClickYes}
        />

        {/* loading image */}
        <div className='wrap-loading'>
          <img src={loader} alt='로딩 이미지' />
        </div>

        {/* header */}
        <Navbar fixed="top" className="title">
          <div className="goBackBtn"><div style={{ color: '#fff' }}><FontAwesomeIcon icon={faArrowCircleLeft} className="btn-home" /></div></div>
          <span style={{ float: 'unset', marginRight: '.5rem' }} className={this.state.usrInfo && this.state.CL_GU === this.state.usrInfo.BLUE_NM ? 'blue-point' : this.state.usrInfo && this.state.CL_GU === this.state.usrInfo.RED_NM ? 'red-point' : this.state.CL_GU === '회복' ? 'green-point' : this.state.CL_GU === '차감' ? 'deduction-point' : ''}>{this.state.CL_GU}</span>
          {this.state.CL_NM}
        </Navbar>

        <ListGroup variant="flush" style={{ marginTop: '3.4rem', paddingBottom: '4.2rem' }}>
          {resultList}
        </ListGroup>

        {fn_set_footer('')}
      </>
    );
  }
}

export default RuleDetailListCmp;